import ClassAddRemove from '../utils.common/classAddRemove';

class ButtonPanel {
    constructor(button, selectorElement = document) {
        this._handleClick = this._handleClick.bind(this);

        this.button = button;
        this.panel = this._getPanel(selectorElement);
    }

    _getPanel(selectorElement) {
        if (!this.button) return;

        const panelId = this.button.getAttribute("aria-controls");
        if (!panelId) return;

        return selectorElement.querySelector(`#${panelId}`);
    }

    _handleClick() {
        if (this.panel.hidden) {
            this._show();
            this._onClickCb(this);
        }
    }

    _show() {
        this._hidePanel(false);
    }

    _hidePanel(hidden) {
        this.panel.hidden = hidden;
        ClassAddRemove(this.button, "active", !hidden);
        this.active = !hidden;
    }

    hide() {
        this._hidePanel(true);
    }

    init(onClickCb) {
        this._onClickCb = onClickCb;
        this.active = !this.panel.hidden;
        this.button.addEventListener("click", this._handleClick);
    }

    destroy() {
        this.button.removeEventListener("click", this._handleClick);
    }
}

export default class StepsBlock extends HTMLElement {
    constructor() {
        super();

        this._handleButtonClick = this._handleButtonClick.bind(this);

        this._previousBlock = this.parentElement.previousSibling;
        this._tabButtons = this.querySelectorAll("button[role='tab']");
        this._currentPanel;
    }

    _createButtonPanels() {
        let buttonPanels = [];

        [].forEach.call(this._tabButtons, (item) => {
            const tempButtonPanel = new ButtonPanel(item, this);

            if (tempButtonPanel.button && tempButtonPanel.panel) {
                tempButtonPanel.init(this._handleButtonClick);
                buttonPanels[buttonPanels.length] = tempButtonPanel;
            };
        });

        return buttonPanels;
    }

    _handleButtonClick(activeButtonPanel) {
        [].forEach.call(this._buttonPanels, (item) => {
            if (item !== activeButtonPanel && item.active) {
                item.hide();
            }
        });
    }

    connectedCallback() {
        if (this._previousBlock?.matches('.component-wrap')) {
            this._previousBlock.querySelector('.component').classList.add('component--pad-steps');
        }

        if (this._tabButtons && this._tabButtons.length > 0) {
            this._buttonPanels = this._createButtonPanels();
        }
    }

    disconnectedCallback() {
        if (this._buttonPanels) {
            [].forEach.call(this._buttonPanels, (item) => {
                item.destroy();
            });
        }
    }
}

customElements.define('steps-block', StepsBlock, { extends: 'section' });
